export default __webpack_public_path__ + "static/media/link-o.609e802d.svg";